(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(function(){
  var panel=document.querySelector('[data-search-panel]');
  if(!panel||panel.dataset.wired)return; panel.dataset.wired='1';
  var backdrop=document.querySelector('.site-search-backdrop');
  var input=panel.querySelector('[data-search-input]');
  var results=panel.querySelector('[data-search-results]');
  var openers=document.querySelectorAll('[data-search-open]');
  var closers=document.querySelectorAll('[data-search-close]');
  var t,ctrl;
  function esc(s){return String(s).replace(/[&<>"']/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}
  function money(p){return '€ '+String(p).replace('.',',')}
  function open(e){if(e)e.preventDefault();panel.hidden=false;if(backdrop)backdrop.hidden=false;
    document.body.style.overflow='hidden';
    openers.forEach(function(o){o.setAttribute('aria-expanded','true')});
    setTimeout(function(){input.focus()},30);}
  function close(){panel.hidden=true;if(backdrop)backdrop.hidden=true;document.body.style.overflow='';
    openers.forEach(function(o){o.setAttribute('aria-expanded','false')});}
  openers.forEach(function(o){o.addEventListener('click',open)});
  closers.forEach(function(c){c.addEventListener('click',close)});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!panel.hidden)close()});
  function run(q){
    if(ctrl)ctrl.abort(); ctrl=new AbortController();
    var url='/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
    fetch(url,{signal:ctrl.signal}).then(function(r){return r.json()}).then(function(d){
      var items=(d.resources&&d.resources.results&&d.resources.results.products)||[];
      if(!items.length){results.innerHTML='<p class="ss-empty">Geen producten gevonden voor &ldquo;'+esc(q)+'&rdquo;.</p>';return;}
      var html=items.map(function(p){
        var img=p.image?'<img src="'+p.image+'&width=96" alt="" loading="lazy">':'<span class="ss-noimg"></span>';
        return '<a class="ss-result" href="'+p.url+'">'+img+'<span class="t">'+esc(p.title)+'</span><span class="p">'+money(p.price)+'</span></a>';
      }).join('');
      html+='<a class="ss-all" href="/search?q='+encodeURIComponent(q)+'&options[prefix]=last&type=product">Alle resultaten voor &ldquo;'+esc(q)+'&rdquo; &rarr;</a>';
      results.innerHTML=html;
    }).catch(function(err){if(err.name!=='AbortError')results.innerHTML=''});
  }
  input.addEventListener('input',function(){
    clearTimeout(t); var q=input.value.trim();
    if(q.length<2){results.innerHTML='';return;}
    t=setTimeout(function(){run(q)},220);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
